<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content class="small-content">
    <p>{{data.text}}</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        {{data.buttonText || 'Ok'}}
    </button>
</mat-dialog-actions>
